import _ from "lodash";
import qs from "qs";
import { env } from "src/configs/env";

export function parseQuery<T>(queryString: string): T | null {
  const queryStringLastIndex = queryString.lastIndexOf("?");
  if (queryStringLastIndex === -1) {
    return null;
  }
  const queryParams: any = qs.parse(
    queryString.substring(queryStringLastIndex + 1)
  );
  return queryParams as T;
}

export function stringifyQuery(params: Record<string, unknown>) {
  return qs.stringify(params);
}

export function makeQueryParams(params?: Record<string, any>) {
  return !_.isEmpty(params) ? `?${stringifyQuery(params!)}` : "";
}

export const getTalkSalesFormUri = (isKo: boolean) => {
  if (isKo) {
    return "https://haechi.typeform.com/to/YgoqYhFJ?utm_source=website&utm_campaign=main";
  }
  return "https://haechi.typeform.com/to/lQJKlKpb?utm_source=website&utm_campaign=main";
};

export const getDashboardUrl = () => {
  return `${env.dashboardUrl}${makeQueryParams({ utm_source: "homepage" })}`;
};
